import { render, staticRenderFns } from "./TotalsSettings.vue?vue&type=template&id=0234f1f7"
import script from "./TotalsSettings.vue?vue&type=script&lang=ts"
export * from "./TotalsSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0234f1f7')) {
      api.createRecord('0234f1f7', component.options)
    } else {
      api.reload('0234f1f7', component.options)
    }
    module.hot.accept("./TotalsSettings.vue?vue&type=template&id=0234f1f7", function () {
      api.rerender('0234f1f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/TotalsSettings.vue"
export default component.exports